// 风险评估页面映射
export const controlMap = {
  '101': 'Chemical',
  '102': 'Chemical',
  '103': 'Chemical',
  '104': 'Chemical',
  '105': 'Chemical',
  '106': 'Chemical',
  '107': 'Industrial',
  '108': 'Industrial',
  '110': 'Industrial',
  '111': 'Industrial',
  '112': 'Industrial',
  '113': 'Chemical',
  '114': 'SurfaceMine',
  '115': 'UndergroundMine',
  '116': 'TailingsPond',
  '117': 'Fireworks',
  '118': 'Port',
  '119': 'RailFreight',
  '120': 'Construction',
  '121': 'Industrial',
  '122': 'Chemical',
  '123': 'Industrial',
  '124': 'Industrial',
  '126': 'Industrial',
  '127': 'Industrial',
  '128': 'Industrial',
  '129': 'Industrial',
  '132': 'Construction',
  '133': 'Construction',
  '134': 'Construction',
  '135': 'Construction',
  '136': 'Boom',
  '137': 'Industrial',
  '138': 'Port',
  '139': 'Construction',
  '140': 'Chemical',
  '141': 'Chemical',
  '144': 'Shipping',
  '145': 'HazardousWaste',
  '109': 'Boom',
  '201': 'Restaurant',
  '202': 'Hospital',
  '203': 'Tower',
  '204': 'Religion',
  '205': 'Stadium',
  '206': 'TouristPlaces',
  '207': 'School',
  '208': 'Hotel',
  '209': 'ElderlyInstitution',
  '210': 'Cultural',
  '211': 'Market',
  '212': 'VillageInCity',
  '213': 'School',
  '214': 'Cultural',
  '215': 'Cultural',
  '216': 'Hotel',
  '219': 'School',
  '220': 'Nursery',
  '223': 'Market',
  '228': 'TouristPlaces',
  '230': 'School',
  '231': 'filmAndTelevision',
  '301': 'Bridge',
  '302': 'Tunnel',
  '303': 'Dam',
  '304': 'Station',
  '305': 'RoadTransport',
  '306': 'GasAndChemicals',
  '307': 'Pipeline',
  '308': 'DangerRoadTransport',
  '309': 'ConstructionWaste',
  '310': 'Fishery',
  '312': 'CityLitter',
  '313': 'BulkMaterial',
  '314': 'Highway',
  '315': 'Highway',
  '316': 'Industrial',
  '317': 'Industrial',
  '318': 'RiskHydropowerStation',
  '319': 'RoadTransport',
  '320': 'WaterwayPassenger',
  '321': 'Railway',
  '322': 'UrbanMassTransit',
  '332': 'TouristPlaces',
  '335': 'WaterwayFreightage',
  '403': 'Construction',
  '501': 'ElderlyInstitution',
  '502': 'ElderlyInstitution',
  '503': 'Cultural',
  '504': 'Bridge',
  '505': 'Tunnel',
  '601': 'TouristPlaces',
  '602': 'Cultural',
  '603': 'TouristPlaces',
  '604': 'TouristPlaces',
  '605': 'TouristPlaces',
  '606': 'Cultural',
  '607': 'Cultural',
  '608': 'Cultural',
  '609': 'Cultural',
  '610': 'Hotel',
  '611': 'Bridge',
  '612': 'Tunnel',
  '613': 'School',
  '614': 'School',
  '615': 'School',
  '616': 'School',
  '617': 'TouristPlaces',
  '618': 'DrownPrevent'
}
// 安全基本信息页面映射
export const safeMap = {
  '101': 'Chemical',
  '102': 'Chemical',
  '103': 'Chemical',
  '104': 'GasStation',
  '105': 'NaturalGas',
  '106': 'NaturalGas',
  '107': 'Metallurgy',
  '108': 'Metallurgy',
  '109': 'Explosion',
  '110': 'Weave',
  '111': 'Weave',
  '112': 'Weave',
  '113': 'Electricity',
  '114': 'SurfaceMine',
  '115': 'SurfaceMine',
  '116': 'SurfaceMine',
  '117': 'FireWork',
  '118': 'Port',
  '119': 'RailFreightBase',
  '120': 'ConstructionBase',
  '121': 'Weave',
  '122': 'Chemical',
  '123': 'Weave',
  '124': 'Industrial',
  '126': 'Weave',
  '127': 'Weave',
  '128': 'Weave',
  '129': 'Weave',
  '132': 'ConstructionBase',
  '133': 'ConstructionBase',
  '134': 'ConstructionBase',
  '135': 'ConstructionBase',
  '136': 'Explosion',
  '137': 'Weave',
  '138': 'Port',
  '139': 'ConstructionBase',
  '140': 'Chemical',
  '141': 'GasStation',
  '144': 'Shipping',
  '145': 'HazardousWaste',
  '201': 'Restaurant',
  '202': 'Hospital',
  '203': 'Tower',
  '204': 'Religion',
  '205': 'CrowdedPlace',
  '206': 'TouristPlace',
  '207': 'School',
  '208': 'Hotel',
  '209': 'CrowdedPlace',
  '210': 'CrowdedPlace',
  '211': 'Market',
  '212': 'VillageInCity',
  '213': 'School',
  '214': 'CrowdedPlace',
  '215': 'CrowdedPlace',
  '216': 'Hotel',
  '219': 'School',
  '220': 'Nursery',
  '223': 'Market',
  '228': 'TouristPlace',
  '230': 'School',
  '231': 'CrowdedPlace',
  '301': 'Bridge',
  '302': 'Tunnel',
  '303': 'Dam',
  '304': 'Station',
  '305': 'RoadTransport',
  '306': 'GasAndChemicals',
  '307': 'Pipeline',
  '308': 'DangerRoadTransport',
  '309': 'ConstructionWaste',
  '310': 'Fishery',
  '312': 'Electricity',
  '313': 'BulkMaterial',
  '314': 'Highway',
  '315': 'Highway',
  '316': 'Weave',
  '317': 'Weave',
  '318': 'Electricity',
  '319': 'RoadTransport',
  '320': 'WaterwayPassenger',
  '321': 'Railway',
  '322': 'UrbanMassTransit',
  '332': 'TouristPlace',
  '335': 'WaterwayFreightage',
  '403': 'ConstructionBase',
  '501': 'CrowdedPlace',
  '502': 'CrowdedPlace',
  '209': 'CrowdedPlace',
  '503': 'CrowdedPlace',
  '504': 'Bridge',
  '505': 'Tunnel',
  '601': 'TouristPlace',
  '602': 'CrowdedPlace',
  '603': 'TouristPlace',
  '604': 'TouristPlace',
  '605': 'TouristPlace',
  '606': 'CrowdedPlace',
  '607': 'CrowdedPlace',
  '608': 'CrowdedPlace',
  '609': 'CrowdedPlace',
  '610': 'Hotel',
  '611': 'Bridge',
  '612': 'Tunnel',
  '613': 'School',
  '614': 'School',
  '615': 'School',
  '616': 'School',
  '617': 'TouristPlace',
  '618': 'DrownPrevent'
}
// 是否划分单元
export const showUnitMap = {
  '101': true,
  '102': true,
  '103': true,
  '104': true,
  '105': true,
  '106': true,
  '107': true,
  '108': true,
  '109': true,
  '110': true,
  '111': true,
  '112': true,
  '113': true,
  '114': true,
  '115': true,
  '116': true,
  '117': true,
  '118': true,
  '119': true,
  '120': true,
  '121': true,
  '122': true,
  '123': true,
  '124': true,
  '126': true,
  '127': true,
  '128': true,
  '129': true,
  '132': true,
  '133': true,
  '134': true,
  '135': true,
  '136': true,
  '137': true,
  '138': true,
  '139': true,
  '140': true,
  '141': true,
  '144': true,
  '145': true,
  '201': true,
  '202': true,
  '203': true,
  '204': true,
  '205': true,
  '206': true,
  '207': true,
  '208': true,
  '209': true,
  '210': false,
  '211': true,
  '212': false,
  '213': true,
  '214': false,
  '215': false,
  '216': true,
  '219': true,
  '220': true,
  '223': true,
  '228': true,
  '230': true,
  '231': false,
  '301': true,
  '302': true,
  '303': true,
  '304': false,
  '305': true,
  '306': false,
  '307': false,
  '308': true,
  '309': false,
  '310': true,
  '312': true,
  '313': true,
  '314': true,
  '315': true,
  '316': true,
  '317': true,
  '318': true,
  '319': true,
  '320': false,
  '321': true,
  '322': true,
  '332': true,
  '335': false,
  '403': true,
  '501': true,
  '502': true,
  '503': false,
  '504': true,
  '505': true,
  '601': true,
  '602': false,
  '603': true,
  '604': true,
  '605': true,
  '606': false,
  '607': false,
  '608': false,
  '609': false,
  '610': true,
  '611': true,
  '612': true,
  '613': true,
  '614': true,
  '615': true,
  '616': true,
  '617': true
}
// 单元划分原则
const IndustrialPrinciple = `（1）针对企业的功能分区和总平面布置，从空间上将企业划分为若干单元，单元划分应涵盖企业总平面布置内涉及生产工艺、设备设施、作业环节的全部范围。<div style="margin-bottom: 10px"></div>
                             （2）危险化学品储罐以罐组防火堤为单元进行划分。<div style="margin-bottom: 10px"></div>
                             （3）生产装置以防火分区为独立单元进行划分，与生产装置毗邻布置、紧密相联的辅助中间储罐、设备设施等与生产装置划分为同一单元。<div style="margin-bottom: 10px"></div>
                             （4）仓库以独立库房（独立建筑物）为界限划分为独立单元。<div style="margin-bottom: 10px"></div>
                             （5）生产厂房以有明显防火划分的独立建筑为单元。<div style="margin-bottom: 10px"></div>
                             （6）其他办公楼、消防泵房、配电室等辅助性设施以独立的建筑进行划分。<div style="margin-bottom: 10px"></div>
                             （7）非生产、储存性的企业整体作为一个单元。`
const commonPrinciple = `（1）以独立建筑物为界限划分为独立单元。<div style="margin-bottom: 10px"></div>
                         （2）若所有场所均在一个单体建筑物内则整体作为一个单元。`
export const principleMap = {
  '101': IndustrialPrinciple,
  '102': IndustrialPrinciple,
  '103': IndustrialPrinciple,
  '104': IndustrialPrinciple,
  '105': IndustrialPrinciple,
  '106': IndustrialPrinciple,
  '107': IndustrialPrinciple,
  '108': IndustrialPrinciple,
  '109': `（1）针对企业的功能分区和总平面布置，从空间上将企业划分为若干单元，单元划分应涵盖企业总平面布置内涉及生产工艺、设备设施、作业环节的全部范围。<div style="margin-bottom: 10px"></div>
          （2）危险化学品储罐以罐组防火堤为单元进行划分。<div style="margin-bottom: 10px"></div>
          （3）生产装置以防火分区为独立单元进行划分，与生产装置毗邻布置、紧密相联的辅助中间储罐、设备设施等与生产装置划分为同一单元。<div style="margin-bottom: 10px"></div>
          （4）仓库以独立库房（独立建筑物）为界限划分为独立单元。<div style="margin-bottom: 10px"></div>
          （5）生产厂房以有明显防火划分的独立建筑为单元。<div style="margin-bottom: 10px"></div>
          （6）其他办公楼、消防泵房、配电室等辅助性设施以独立的建筑进行划分。`,
  '110': IndustrialPrinciple,
  '111': IndustrialPrinciple,
  '112': IndustrialPrinciple,
  '113': IndustrialPrinciple,
  '114': `（1）依据企业各区域、场所功能用途的不同划分为矿外单元和矿山（库）单元两种类型。<div style="margin-bottom: 10px"></div>
        （2）矿外单元包括运输、加工区域，是以独立建筑物为界限划分为独立单元，其中若所有场所均在一个单体建筑物内则整体作为一个单元。
        <div style="margin-bottom: 10px"></div>
        （3）矿山（库）内可整体作为一个风险单元。`,
  '115': `（1）依据企业各区域、场所功能用途的不同划分为矿外单元和矿山（库）单元两种类型。<div style="margin-bottom: 10px"></div>
        （2）矿外单元包括运输、加工区域，是以独立建筑物为界限划分为独立单元，其中若所有场所均在一个单体建筑物内则整体作为一个单元。
        <div style="margin-bottom: 10px"></div>
        （3）矿山（库）内可整体作为一个风险单元。`,
  '116': '',
  '117': `（1）针对企业的功能分区和总平面布置，从空间上将企业划分为若干单元，单元划分应涵盖企业总平面布置内涉及设备设施、作业环节的全部范围。<div style="margin-bottom: 10px"></div>
          （2）仓库以独立库房（独立建筑物）为界限划分为独立单元。<div style="margin-bottom: 10px"></div>
          （3）其他办公楼、消防泵房、配电室等辅助性设施以独立的建筑进行划分。`,
  '118': `（1）针对港口经营企业的功能分区和总平面布置，从空间上将企业划分为若干单元，主要包括但不限于码头（含泊位）、堆场、罐区、仓库、办公楼及生产附属设施等。单元划分应涵盖企业总平面布置内涉及生产工艺、设备设施、作业环节的全部范围。<div style="margin-bottom: 10px"></div>
          （2）储罐区以罐组防火堤为单元进行划分。<div style="margin-bottom: 10px"></div>
          （3）码头（含泊位）以空间相对独立性，划分为不同的码头单元。<div style="margin-bottom: 10px"></div>
          （4）仓库以独立库房（独立建筑物）为界限划分为独立单元。<div style="margin-bottom: 10px"></div>
          （5）集装箱堆场和散货堆场以具有消防功能的支道为界限进行单元划分。<div style="margin-bottom: 10px"></div>
          （6）客运（候船）大楼以及其他办公楼、消防泵房、配电室等辅助性设施以独立的建筑进行划分。<div style="margin-bottom: 10px"></div>
          注：单元类型，货物码头选码头，客运码头选客运码头。`,
  '119': `① 针对铁路货运站场的功能分区和总平面布置，从空间上将企业划分为若干单元，主要包括但不限于装卸站台、罐区、仓库、办公楼及附属设施等。单元划分应涵盖企业总平面布置内涉及生产工艺、设备设施、作业环节的全部范围。<div style="margin-bottom: 10px"></div>
          ② 装卸专用作业区域可划分为独立的单元。<div style="margin-bottom: 10px"></div>
          ③ 储罐区以罐组防火堤为单元进行划分。<div style="margin-bottom: 10px"></div>
          ⑤ 仓库以独立库房（独立建筑物）为界限划分为独立单元。<div style="margin-bottom: 10px"></div>
          ⑥ 其他办公楼、消防泵房、配电室等辅助性设施以独立的建筑进行划分。`,
  '120': `（1）依据建设项目施工总平面图划分为办公生活区和施工作业区两类单元。<div style="margin-bottom: 10px"></div>
        （2）办公生活区以独立建筑物为界限划分为独立单元。若所有场所均在一个单体建筑物内则整体作为一个单元。<div style="margin-bottom: 10px"></div>
        （3）施工作业区可整体作为施工作业区风险单元。`,
  '121': IndustrialPrinciple,
  '122': IndustrialPrinciple,
  '123': IndustrialPrinciple,
  '124': IndustrialPrinciple,
  '126': IndustrialPrinciple,
  '127': IndustrialPrinciple,
  '128': IndustrialPrinciple,
  '129': IndustrialPrinciple,
  '132': `（1）依据建设项目施工总平面图划分为办公生活区和施工作业区两类单元。<div style="margin-bottom: 10px"></div>
          （2）办公生活区以独立建筑物为界限划分为独立单元。若所有场所均在一个单体建筑物内则整体作为一个单元。<div style="margin-bottom: 10px"></div>
          （3）施工作业区可整体作为施工作业区风险单元。`,
  '133': `（1）依据建设项目施工总平面图划分为办公生活区、施工作业区及加工生产区三类单元。<div style="margin-bottom: 10px"></div>
  （2）办公生活区以独立建筑物为界限划分为独立单元。若所有场所均在一个单体建筑物内则整体作为一个单元。<div style="margin-bottom: 10px"></div>
  （3）施工作业区可整体作为施工作业区风险单元，也可以平面布置或功能分区划分为各个独立单元，如以各隧道、桥梁、标段分别划分为一个独立单元。<div style="margin-bottom: 10px"></div>
  （4）加工生产区可整体作为加工生产区风险单元，也可以按平面布置或功能分区划分为各个独立单元。`,
  '134': `（1）依据建设项目施工总平面图划分为办公生活区、施工作业区及加工生产区三类单元。<div style="margin-bottom: 10px"></div>
      （2）办公生活区以独立建筑物为界限划分为独立单元。若所有场所均在一个单体建筑物内则整体作为一个单元。<div style="margin-bottom: 10px"></div>
      （3）施工作业区可整体作为施工作业区风险单元，也可以建设项目线路、站点、车辆段等布置情况或功能分区进一步划分为各个独立的施工作业区单元，如线路以各线路区间划分为独立单元，站点以各独立站点划分为独立单元，车辆段等可作为一个整体单元也可按独立建（构）筑物为界限进一步划分为独立单元。<div style="margin-bottom: 10px"></div>
      （4）加工生产区可整体作为加工生产区风险单元，也可以按平面布置或功能分区划分为各个独立单元。`,
  '135': `（1）依据建设项目施工总平面图划分为办公生活区和施工作业区两类单元。<div style="margin-bottom: 10px"></div>
        （2）办公生活区以独立建筑物为界限划分为独立单元。若所有场所均在一个单体建筑物内则整体作为一个单元。<div style="margin-bottom: 10px"></div>
        （3）施工作业区可整体作为施工作业区风险单元。`,
  '136': `（1）针对企业的功能分区和总平面布置，从空间上将企业划分为若干单元，单元划分应涵盖企业总平面布置内涉及生产工艺、设备设施、作业环节的全部范围。<div style="margin-bottom: 10px"></div>
          （2）危险化学品储罐以罐组防火堤为单元进行划分。<div style="margin-bottom: 10px"></div>
          （3）生产装置以防火分区为独立单元进行划分，与生产装置毗邻布置、紧密相联的辅助中间储罐、设备设施等与生产装置划分为同一单元。<div style="margin-bottom: 10px"></div>
          （4）仓库以独立库房（独立建筑物）为界限划分为独立单元。<div style="margin-bottom: 10px"></div>
          （5）生产厂房以有明显防火划分的独立建筑为单元。<div style="margin-bottom: 10px"></div>
          （6）其他办公楼、消防泵房、配电室等辅助性设施以独立的建筑进行划分。`,
  '137': IndustrialPrinciple,
  '138': `（1）针对港口经营企业的功能分区和总平面布置，从空间上将企业划分为若干单元，主要包括但不限于码头（含泊位）、堆场、罐区、仓库、办公楼及生产附属设施等。单元划分应涵盖企业总平面布置内涉及生产工艺、设备设施、作业环节的全部范围。<div style="margin-bottom: 10px"></div>
          （2）储罐区以罐组防火堤为单元进行划分。<div style="margin-bottom: 10px"></div>
          （3）码头（含泊位）以空间相对独立性，划分为不同的码头单元。<div style="margin-bottom: 10px"></div>
          （4）仓库以独立库房（独立建筑物）为界限划分为独立单元。<div style="margin-bottom: 10px"></div>
          （5）集装箱堆场和散货堆场以具有消防功能的支道为界限进行单元划分。<div style="margin-bottom: 10px"></div>
          （6）其他办公楼、消防泵房、配电室等辅助性设施以独立的建筑进行划分。`,
  '139': `（1）依据建设项目施工总平面图划分为办公生活区、施工作业区及加工生产区三类单元。<div style="margin-bottom: 10px"></div>
            （2）办公生活区以独立建筑物为界限划分为独立单元。若所有场所均在一个单体建筑物内则整体作为一个单元。<div style="margin-bottom: 10px"></div>
            （3）施工作业区（加工生产区）可整体作为施工作业区（加工生产区）风险单元，也可以按平面布置或功能分区划分为各个独立单元。`,
  '140': IndustrialPrinciple,
  '141': IndustrialPrinciple,
  '144': `（1）生产装置以防火分区为独立单元进行划分，与生产装置毗邻布置、紧密相联的辅助中间储罐、设备设施等与生产装置划分为同一单元。若装置的各工序或作业区在平面布置上可独立分区，也可按工序或作业区进行单元划分。<div style="margin-bottom: 10px"></div>
        （2）生产厂房以有明显防火划分的独立建筑为单元。<div style="margin-bottom: 10px"></div>
        （3）其他办公楼、消防泵房、配电室等辅助性设施以独立的建筑进行划分。<div style="margin-bottom: 10px"></div>
        （4）危险化学品储罐以罐组防火堤为单元进行划分。<div style="margin-bottom: 10px"></div>
        （5）仓库以独立库房（独立建筑物）为界限划分为独立单元。<div style="margin-bottom: 10px"></div>
        （6）构成重大危险源划分为独立单元。<div style="margin-bottom: 10px"></div>
        （7）码头（含泊位）以空间相对独立性，划分为不同的码头单元。`,
  '145': IndustrialPrinciple,
  '201': commonPrinciple,
  '202': commonPrinciple,
  '203': `（1）以独立建筑物为界限划分为独立单元。<div style="margin-bottom: 10px"></div>
          （2）若所有场所均在一个单体建筑物内则整体作为一个单元。`,
  '204': commonPrinciple,
  '205': commonPrinciple,
  '206': `（1）依据园（景）区各区域、场所功能用途的不同进行划分。<div style="margin-bottom: 10px"></div>
        （2）除独立建筑物需划分为独立单元外。园（景）区其他区域可整体作为一个风险单元。`,
  '207': commonPrinciple,
  '208': commonPrinciple,
  '209': `（1）以独立建筑物为界限划分为独立单元。<div style="margin-bottom: 10px"></div>
          （2）若所有场所均在一个单体建筑物内则整体作为一个单元`,
  '210': '',
  '211': commonPrinciple,
  '212': '',
  '213': commonPrinciple,
  '214': '',
  '215': '',
  '216': commonPrinciple,
  '219': commonPrinciple,
  '220': commonPrinciple,
  '223': commonPrinciple,
  '228': `（1）依据园（景）区各区域、场所功能用途的不同进行划分。<div style="margin-bottom: 10px"></div>
         （2）除独立建筑物需划分为独立单元外。园（景）区其他区域可整体作为一个风险单元。`,
  '230': commonPrinciple,
  '231': '',
  '301': '',
  '302': '',
  '303': '',
  '304': '',
  '305': `（1）风险单元分为交通场站单元和运输单元两种类型。<div style="margin-bottom: 10px"></div>
        （2）交通场站单元以独立建筑物为界限划分为独立单元。若所有场所均在一个单体建筑物内则整体作为一个单元。<div style="margin-bottom: 10px"></div>
        （3）运输单元指企业车辆管理，需建立风险单元，填报单元参数信息，但无需绘制单元范围。
        `,
  '306': '',
  '307': '',
  '308': `（1）风险单元分为交通场站单元和运输单元两种类型。<div style="margin-bottom: 10px"></div>
        （2）交通场站单元以独立建筑物为界限划分为独立单元。若所有场所均在一个单体建筑物内则整体作为一个单元。<div style="margin-bottom: 10px"></div>
        （3）运输单元指企业车辆管理，需建立风险单元，填报单元参数信息，但无需绘制单元范围。`,
  '309': '',
  '310': '',
  '312': IndustrialPrinciple,
  '313': `（1）风险单元分为交通场站单元和运输单元两种类型。<div style="margin-bottom: 10px"></div>
        （2）交通场站单元以独立建筑物为界限划分为独立单元。若所有场所均在一个单体建筑物内则整体作为一个单元。<div style="margin-bottom: 10px"></div>
        （3）运输单元指企业车辆管理，需建立风险单元，填报单元参数信息，但无需绘制单元范围。`,
  '314': `（1）风险单元分为交通场站单元和运输单元两种类型。<div style="margin-bottom: 10px"></div>
          （2）交通场站单元以独立建筑物为界限划分为独立单元。若所有场所均在一个单体建筑物内则整体作为一个单元。<div style="margin-bottom: 10px"></div>
          （3）运输单元指企业车辆管理，需建立风险单元，填报单元参数信息，但无需绘制单元范围`,
  '315': `（1）风险单元分为交通场站单元和运输单元两种类型。<div style="margin-bottom: 10px"></div>
          （2）交通场站单元以独立建筑物为界限划分为独立单元。若所有场所均在一个单体建筑物内则整体作为一个单元。<div style="margin-bottom: 10px"></div>
          （3）运输单元指企业车辆管理，需建立风险单元，填报单元参数信息，但无需绘制单元范围`,
  '316': IndustrialPrinciple,
  '317': IndustrialPrinciple,
  '318': IndustrialPrinciple,
  '319': `（1）风险单元分为交通场站单元和运输单元两种类型。<div style="margin-bottom: 10px"></div>
            （2）交通场站单元以独立建筑物为界限划分为独立单元。若所有场所均在一个单体建筑物内则整体作为一个单元。<div style="margin-bottom: 10px"></div>
            （3）运输单元指企业车辆管理，需建立风险单元，填报单元参数信息，但无需绘制单元范围。`,
  '320': '',
  '321': `（1）风险单元分为交通场站单元和运输单元两种类型。<div style="margin-bottom: 10px"></div>
          （2）交通场站单元以独立建筑物为界限划分为独立单元。若所有场所均在一个单体建筑物内则整体作为一个单元。<div style="margin-bottom: 10px"></div>
          （3）运输单元指企业车辆管理，需建立风险单元，填报单元参数信息，但无需绘制单元范围。<div style="margin-bottom: 10px"></div>`,
  '322': `（1）单元分为线路单元和车辆段单元两种类型；<div style="margin-bottom: 10px"></div>
  （2）线路单元以各运营线路划分为独立单元，包含站点、区间；<div style="margin-bottom: 10px"></div>
  （3）车辆段单元以独立建（构）筑物为界限划分为独立单元，如办公及生活区，培训中心、停车库、综合维修中心、材料总库等。若所有场所均在一个单体建筑物内则整体作为一个单元。`,
  '332': `（1）依据园（景）区各区域、场所功能用途的不同进行划分。<div style="margin-bottom: 10px"></div>
          （2）除独立建筑物需划分为独立单元外。园（景）区其他区域可整体作为一个风险单元。`,
  '335': '',
  '403': `（1）依据建设项目施工总平面图划分为办公生活区、施工作业区及加工生产区三类单元。<div style="margin-bottom: 10px"></div>
          （2）办公生活区以独立建筑物为界限划分为独立单元。若所有场所均在一个单体建筑物内则整体作为一个单元。<div style="margin-bottom: 10px"></div>
          （3）施工作业区（加工生产区）可整体作为施工作业区（加工生产区）风险单元，也可以按平面布置或功能分区划分为各个独立单元。`,
  '501': `（1）以独立建筑物为界限划分为独立单元。<div style="margin-bottom: 10px"></div>
          （2）若所有场所均在一个单体建筑物内则整体作为一个单元`,
  '502': `（1）以独立建筑物为界限划分为独立单元。<div style="margin-bottom: 10px"></div>
          （2）若所有场所均在一个单体建筑物内则整体作为一个单元`,
  '503': '',
  '504': '',
  '505': '',
  '601': `（1）依据园（景）区各区域、场所功能用途的不同进行划分。<div style="margin-bottom: 10px"></div>
          （2）除独立建筑物需划分为独立单元外。园（景）区其他区域可整体作为一个风险单元。`,
  '602': '',
  '603': `（1）依据园（景）区各区域、场所功能用途的不同进行划分。<div style="margin-bottom: 10px"></div>
          （2）除独立建筑物需划分为独立单元外。园（景）区其他区域可整体作为一个风险单元。`,
  '604': `（1）依据园（景）区各区域、场所功能用途的不同进行划分。<div style="margin-bottom: 10px"></div>
          （2）除独立建筑物需划分为独立单元外。园（景）区其他区域可整体作为一个风险单元。`,
  '605': `（1）依据园（景）区各区域、场所功能用途的不同进行划分。<div style="margin-bottom: 10px"></div>
          （2）除独立建筑物需划分为独立单元外。园（景）区其他区域可整体作为一个风险单元。`,
  '606': '',
  '607': '',
  '608': '',
  '609': '',
  '610': commonPrinciple,
  '611': '',
  '612': '',
  '613': commonPrinciple,
  '614': commonPrinciple,
  '615': commonPrinciple,
  '616': commonPrinciple,
  '617': `（1）依据园（景）区各区域、场所功能用途的不同进行划分。<div style="margin-bottom: 10px"></div>
          （2）除独立建筑物需划分为独立单元外。园（景）区其他区域可整体作为一个风险单元。`,
  '618': ''
}
export const controlNameMap = {
  '101': '危险化学品生企业',
  '102': '带储存的危险化学品经营企业',
  '103': '危险化学品使用企业',
  '104': '加油站',
  '105': '天然气站场',
  '106': '液化气储配站',
  '107': '冶金企业',
  '108': '有色企业',
  '109': '民用爆炸物品企业',
  '110': '建材企业',
  '121': '轻工企业',
  '111': '机械企业',
  '112': '纺织企业',
  '113': '电力企业',
  '114': '露天矿山',
  '115': '地下矿山',
  '116': '尾矿库',
  '117': '烟花爆竹企业',
  '118': '港口经营企业（福州港口）',
  '119': '铁路货运站场',
  '120': '建筑业',
  '122': '农业与农机(农药、兽药)',
  '123': '农机(含农机作业)',
  '124': '农业与农机(农产品初加工、饲料及饲料添加剂生产)',
  '126': '机动车维修企业',
  '127': '粮食和物资储备行业',
  '128': '烟草',
  '129': '林业',
  '132': '农田水利建设',
  '133': '公路、水运工程建设',
  '134': '城市轨道交通建设',
  '135': '水利工程建设',
  '136': '民爆物品(爆破)',
  '137': '特种设备生产企业',
  '138': '港口经营企业（湄洲湾港口）',
  '139': '房屋建筑工程',
  '140': '加油加气站',
  '141': '加气站',
  '144': '船舶修造企业',
  '145': '危险废物处置企业',
  '201': '餐饮场所',
  '202': '医疗机构',
  '203': '高层建筑',
  '204': '宗教活动场所',
  '205': '体育场馆',
  '206': '旅游景区',
  '207': '学校',
  '208': '非星级酒店',
  '209': '养老机构',
  '210': '公共休闲娱乐场所',
  '211': '商场',
  '213': '技工院校',
  '214': '新闻出版',
  '215': '文物和博物馆',
  '216': '星级饭店（酒店）',
  '219': '职业技能培训机构',
  '220': '托育机构',
  '223': '市场',
  '228': '风景名胜区（林业局）',
  '230': '校外培训机构（教育局）',
  '231': '电影放映场所',
  '301': '公路桥梁',
  '302': '公路隧道',
  '303': '水库大坝',
  '304': '客运车站',
  '305': '旅行社',
  '306': '陆上油气长输管道企业',
  '307': '城镇燃气管道企业',
  '308': '危险货物运输企业',
  '309': '建筑垃圾受纳场',
  '310': '渔业船舶',
  '311': '船舶运输',
  '312': '城市垃圾处理企业',
  '313': '散装物料运输企业',
  '314': '普通货物运输企业',
  '315': '邮政(含快递)',
  '316': '城市供水企业',
  '317': '城市污水处理企业',
  '318': '农村水电站',
  '319': '公路客运企业',
  '320': '水路旅客运输企业',
  '321': '城市公共交通（短途客运企业）',
  '322': '城市轨道交通',
  '332': '城市公园（国有资产监督管理委员会）',
  '335': '水路货物运输企业',
  '403': '市政基础设施工程',
  '501': '社会福利机构',
  '502': '救助站',
  '503': '公共文化场所（文化和旅游局）',
  '504': '市政桥梁（城管）',
  '505': '市政隧道（城管）',
  '601': '风景名胜区（园林中心）',
  '602': '演出场所',
  '603': '城市公园(城乡建设局)',
  '604': '城市公园（市园林中心）',
  '605': '城市公园（林业局）',
  '606': '公共文化场所（文物局）',
  '607': '公共文化场所（自规局）',
  '608': '公共文化场所（科技局）',
  '609': '公共文化场所（共青团委）',
  '610': '民宿',
  '611': '市政桥梁（建设局）',
  '612': '市政隧道（建设局）',
  '613': '校外培训机构（文旅局）',
  '614': '校外培训机构（科技局）',
  '615': '校外培训机构（体育局）',
  '616': '校外培训机构（人社局）',
  '617': '风景名胜区（鼓岭管委会）',
  '618': '防溺水点'
}
// // 企业是单单元还是多单元
// export const controlUnitTypeMap = {
//   '207': 'Single',
//   '109': 'Multi'
// }
// 隐患排查治理情况页面映射
export const controlComplianceMap = {
  // '112': 'Weave',
  // '110': 'BuildingMaterials',
  // '121': 'LightIndustry',
  // '111': 'MechanicalEngineering',
  // '108': 'Nonferrous',
  // '107': 'Metallurgy',
  '118': 'Port',
  // '202': 'Common',
  '101': 'Chemical',
  '102': 'Chemical',
  '114': 'SurfaceMine',
  '115': 'UndergroundMine',
  '116': 'TailingsPond',
  '117': 'Fireworks',
  '119': 'RailFreight',
  '144': 'Shipping'
}

// 需要分类型
export const isNeedType = [207, 118, 219, 138, 202, 213, 230, 119, 117, 318, 114, 115, 116, 313, 314, 315, 312, 308, 305, 120, 132, 133, 134, 139, 135, 319, 321, 322, 403, 613, 614, 615, 616]



// WEBPACK FOOTER //
// ./src/router/control.js